export const parseIcon = (icon?: string) => {
  const iconArr = (icon ?? '').split(' ')

  return { shape: iconArr[0], direction: iconArr[1], default: icon }
}
